export default {
    isLoggedIn: state => {
        return state.accessToken !== null
    },
    canFinishBuyout: state => state.buyoutItemsFormIsSubmitted && state.customerFormIsSubmitted,
    canExportToBoss: state => state.allGoldsmithItemsAreOk && state.noWeightLeft,
    commodityTypes: (state) => state.typeCommodityList,
    commodityPurities: (state) => state.commodityPurities,

}